import { FC } from "react";
import {
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Alert,
} from "@mui/material";
import { Warning } from "@mui/icons-material";
import DeleteIcon from "@/assets/svgs/garbage.svg";
import { tokens } from "@/tokens";

export interface DeleteClusterConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  cluster: CustomsCluster | null;
  documentCount: number;
  hasAuditResults: boolean;
}

export const DeleteClusterConfirmDialog: FC<DeleteClusterConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  cluster,
  documentCount,
  hasAuditResults,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { borderRadius: "12px" },
      }}
    >
      <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        <Warning sx={{ color: tokens.status.danger }} />
        <Typography variant="h6" sx={{ fontWeight: tokens.fontWeight.bold }}>
          Delete Folder?
        </Typography>
      </DialogTitle>
      <DialogContent>
        {cluster && (
          <Box>
            <Typography variant="body1" sx={{ mb: 2 }}>
              Are you sure you want to delete this folder and all its
              documents?
            </Typography>
            <Alert severity="warning" sx={{ mb: 2 }}>
              <Typography variant="body2">
                <strong>This action cannot be undone.</strong> The following
                will be permanently deleted:
              </Typography>
              <Box component="ul" sx={{ mt: 1, mb: 0, pl: 2 }}>
                <li>
                  <strong>
                    {documentCount}
                  </strong>{" "}
                  document
                  {documentCount !== 1
                    ? "s"
                    : ""}
                </li>
                {hasAuditResults && (
                  <li>All audit records for this folder</li>
                )}
              </Box>
            </Alert>
            <Box sx={{ p: 2, bgcolor: tokens.bg.hover, borderRadius: tokens.radius.md }}>
              <Typography
                variant="body2"
                sx={{ color: tokens.text.secondary, mb: 0.5 }}
              >
                Folder Entry:
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: tokens.fontWeight.bold }}>
                {cluster.entryNumbers?.[0] || "No Entry Number"}
              </Typography>
            </Box>
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2, gap: 1 }}>
        <Button
          onClick={onClose}
          variant="outlined"
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          startIcon={
            <img
              src={DeleteIcon}
              alt="Delete"
              style={{
                width: 16,
                height: 16,
                filter: "brightness(0) invert(1)",
              }}
            />
          }
        >
          Delete Folder
        </Button>
      </DialogActions>
    </Dialog>
  );
};
